import { CustomerManagement } from 'customer-management/customerManagement';
import { Redirect } from 'react-router-dom';
import { PERMISSIONS } from 'shared/constants';
import { useTitle } from 'shared/hooks';
import { useUserPermissions } from 'shared/hooks/use-user-permissions';
import { ROUTES } from './routes';

export function CustomerManagementResolver() {
  const userPermissions = useUserPermissions();

  useTitle('Customer Management - American Bath');

  if (!userPermissions.includes(PERMISSIONS['customer.view'])) {
    return <Redirect to={ROUTES.unauthorized} />;
  }
  return <CustomerManagement />;
}
